import { render } from "./AiBbTradeValue.vue?vue&type=template&id=10720a9a&scoped=true"
import script from "./AiBbTradeValue.vue?vue&type=script&lang=js"
export * from "./AiBbTradeValue.vue?vue&type=script&lang=js"

import "./AiBbTradeValue.vue?vue&type=style&index=0&id=10720a9a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10720a9a"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiBbTradeValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10720a9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10720a9a', __exports__)) {
    api.reload('10720a9a', __exports__)
  }
  
  module.hot.accept("./AiBbTradeValue.vue?vue&type=template&id=10720a9a&scoped=true", () => {
    api.rerender('10720a9a', render)
  })

}


export default __exports__